import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { provideTranslateService } from '@ngx-translate/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApiModule,
  BASE_PATH,
  Configuration,
  ConfigurationParameters,
} from './api';
import { AuthInterceptor } from './services/auth.interceptor';

const apiConfigFactory = (): Configuration => {
  const params: ConfigurationParameters = {
    withCredentials: true,
    basePath: 'https://dev-assets.trask.cz/be/api',
    credentials: {
      bearerAuth: () => localStorage.getItem('accessToken') || '',
    },
  };
  return new Configuration(params);
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    provideClientHydration(withEventReplay()),
    provideAnimationsAsync(),
    importProvidersFrom(ApiModule.forRoot(apiConfigFactory)),

    provideTranslateService({
      defaultLanguage: 'cs',
    }),
    providePrimeNG({
      theme: {
        preset: Aura,
      },
    }),
  ],
};
